// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".update[data-v-1c1cf521]{color:#fff;background-color:#2961a8;text-align:center;font-weight:700;padding:1.2em 1em}.update a[data-v-1c1cf521]{color:#fff;text-decoration:underline}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
